import { Injectable, OnDestroy } from '@angular/core';
import { RxMethods } from '../common/services/rxjs.service';

@Injectable()
export class DashboardService implements OnDestroy {
  constructor(private rxMethods: RxMethods) { }
  dashboardMenuItems: any;
  // dashboardItems = this.rxMethods.createSubjectService();

  setDashboardItems(menuItems) {
    this.dashboardMenuItems = menuItems;
    // this.dashboardItems.next(menuItems);
  }

  getDashboardItems() {
    // return this.dashboardItems;
  }

  ngOnDestroy(): void {
    // this.dashboardItems.unsubscribe();
  }
}
